import { render, staticRenderFns } from "./OsCampaignSummary.vue?vue&type=template&id=434c4200&scoped=true"
import script from "./OsCampaignSummary.vue?vue&type=script&lang=ts"
export * from "./OsCampaignSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434c4200",
  null
  
)

export default component.exports